import { SiteAreaData } from './site-area-data';
import { MediaData } from './media-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class SiteData {
  SiteId: string;
  Latitude: number;
  Longitude: number;
  SiteAddress: string;
  SiteAreas: { [key: string]: SiteAreaData };
  SiteName: string;
  SiteReference: string;
  SiteStatusId: string;
  Staff: string[];
  Contracts: string[];
  PrincipleContractId: string;
  SiteDepotId: string;
  SiteImage: MediaData;
  IsCameraAllowed: boolean;
  IsManageStockControl: boolean;
  TotalTonnage: number;
  InspectionDue: number;
  ScaffoldCount: number;
  AreaCount: number;
  Deleted: boolean;
  LastModified: string;
}


